import { IndividualAccountTypeEnum } from "~/graphql/supergraphEnums";
import { FormValues } from "./types";

export const INITIAL_VALUES: FormValues = {
  accountType: IndividualAccountTypeEnum.Individual,
  firstName: "",
  middleName: "",
  lastName: "",
  dateOfBirth: undefined,
  streetLine1: "",
  streetLine2: "",
  // default create forms to US so state picker is shown
  country: "",
  city: "",
  stateOrProvince: "",
  zipCode: "",
  taxId: "",
  taxIdType: undefined,
  ownershipPercentage: 0,
  isOwner: false,
  isController: false,
  title: "",
  placeOfBirthCountryId: "",
  nationalityCountryId: "",
  sourceOfWealth: "",
  identificationType: undefined,
  identificationNumber: "",
};

// Key mappings of extracted data from query and form values
export const FIELD_MAPPING: Partial<Record<keyof FormValues, string>> = {
  firstName: "first_name",
  middleName: "middle_name",
  lastName: "last_name",
  dateOfBirth: "date_of_birth",
  streetLine1: "street",
  streetLine2: "street2",
  city: "city",
  stateOrProvince: "state",
  country: "country",
  zipCode: "postal_code",
};
